// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KgEB","delete":"styles_delete__1mjU7","update":"styles_update__257sr","add":"styles_add__Q_0KY"};